import { useState, useEffect } from "react";
import { Alert, Button } from "reactstrap";
import { useSnackBarStyles } from "./styles";
import { VfxSnackbarProps, SetSnackbarPropss } from "./vfxSnackbarProps";

export const Snackbar: React.FC<VfxSnackbarProps> = (props) => {
    SetSnackbarPropss(props);
    const snackBarStyles = useSnackBarStyles();
    const [isVisible, setIsVisible] = useState(props.open);
    
    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        if (props.open) {
            setIsVisible(true);

            timeoutId = setTimeout(() => {
                props.handleClose();
                setIsVisible(false);
            }, props.autoHideDuration);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, [props.open, props.autoHideDuration, props.handleClose]);

    const onClose = () => {
        props.handleClose();
        setIsVisible(false);
    };

    return (
        <div style={snackBarStyles.container}>
            {isVisible && (
                <Alert color={props.severity} style={snackBarStyles.alert}>
                    {props.message}
                    <Button close onClick={onClose} style={snackBarStyles.closeButton} />
                </Alert>
            )}
        </div>
    );
};
